import { createContext } from "react";

export interface INavigationHistoryItem {
  label: string;
  path: string;
}

export interface INavigationHistoryContext {
  items: INavigationHistoryItem[];
  navigate: (path: string, label: string, clear?: boolean) => void;
  clear: () => void;
  updateCurrentLabel: (label: string) => void;
}

const NavigationHistoryContext = createContext<INavigationHistoryContext>({
  items: [],
  navigate: () => {},
  clear: () => {},
  updateCurrentLabel: () => {},
});

export default NavigationHistoryContext;
